<template>
  <div class="wrap personal-wrap">
    <div class="flex-column myaccount">
      <div class="mytabs two">
        <div class="tab" @click="tabHeaderOne(0)" :class="{'active': activeTab =='tab1'}">
          <mu-badge content="0" circle secondary badgeClass="none-badge">
            <p>未使用</p>
          </mu-badge>
        </div>
        <div class="tab" @click="tabHeaderTwo(2)" :class="{'active': activeTab =='tab2'}">
          <mu-badge content="0" circle secondary badgeClass="none-badge">
            <p>已失效</p>
          </mu-badge>
        </div>
      </div>
      <mu-infinite-scroll :loading="loadShow" loadingText="拼命加载中" class="load" v-if="loadShow" />
      <empty imgpath="/static/images/empty_red_packet_3x.png" emptytext="您还没有相关红包" v-if="memCouponMsg.length == 0 && !loadShow"></empty>
      <!-- 全部有效 memCouponMsgExpireList.length == 0-->
      <div class="flex-item tab1" v-show="memCouponMsg.length != 0  && !loadShow">
        <mu-list class="acount-list" :class="{'out-date': activeTab =='tab2'}" v-for="(memCouponMsgList,ceffectiveIndex) in memCouponMsg" :key="memCouponMsgList.couponId">
          <mu-list-item>
            <div class="acount-list-left">
              <p class="money" v-if="memCouponMsgList.couponCate != 3">￥
                <label>{{memCouponMsgList.couponAmount}}</label>
              </p>
               <p class="money" v-if="memCouponMsgList.couponCate == 3">
                <label>{{memCouponMsgList.couponDiscount  | discount}}</label>折
              </p>
              <img src="/static/images/coupon_out_of_date_3x.png" v-show="activeTab =='tab2'">
              <p class="limit">{{memCouponMsgList.useableAmount == 0 ? '不限制' : '满'+memCouponMsgList.useableAmount+'可用'}}</p>
            </div>
            <p class="ellipsis gray mgt">
              <label>限品类：</label>{{memCouponMsgList.userTypeName}}</p>
            <p class="ellipsis gray">
              <label>有效期：</label>{{memCouponMsgList.effectiveTime}}-{{memCouponMsgList.expireTime}}</p>
            <div class="account-operate">
              <p class="scan-detail gray" @click="scandetail(ceffectiveIndex)">详细</p>
              <div class="operate">
                <mu-raised-button label="删除" class="account-btn account-btn-gray" @click="deleteitem(memCouponMsgList.couponInstId)" />
                <mu-raised-button label="去使用" class="account-btn account-btn-primary" @click="gouse(memCouponMsgList.storeId,memCouponMsgList.useType)" />
              </div>
            </div>
          </mu-list-item>
          <div class="detail-box" v-if="check(ceffectiveIndex)">
            <p class="gray">
              <label>券名称：</label>{{memCouponMsgList.couponName}}</p>
            <!--  <p class="gray">
             <label>限平台：</label>{{memCouponMsgList.useType}}</p> -->
            <p class="gray">
              <label>券编号：</label>{{memCouponMsgList.couponInstId}}</p>
          </div>
        </mu-list>
        <mu-infinite-scroll :scroller="scroller" :loading="loading" loadingText="" @load="loadMore" />
        <p class="none-goods" v-if="(lastPageNo == currentPage && !loadShow) || (total ==0 && !loadShow) ">没有更多红包啦~</p>
      </div>

    </div>
    <mu-toast v-if="toast1" message="删除成功!" class="custom-toast" />
    <mu-dialog :open="delCoupon" title="删除优惠券" titleClass="dialogTitle" bodyClass="dialogBody" actionsContainerClass="dialogActionsContainer" @close="delCoupon=false">
      您确定要删除这张优惠券么?
      <mu-flat-button slot="actions" @click="delCoupon=false" primary label="否" />
      <mu-flat-button slot="actions" primary @click="getDelMemCoupon(temp)" label="是" />
    </mu-dialog>
  </div>
</template>
<script type="text/javascript">
import menus from '@components/menus/menus';
import myOrdersItem from '@components/myOrdersItem/myOrdersItem';
import empty from '@components/empty/empty';
import { mapActions } from 'Vuex';
export default {
  data() {
    return {
      delCoupon:false,//删除确认弹框
      temp:0,//临时存储id
      activeTab: 'tab1',
      scandetailid: [],
      loadShow: true, //加载
      // 下拉加载相关
      loading: false,
      scroller: null,
      pageNo: 1,
      pageSize: 10,
      total: 0,//z总数量
      lastPageNo:1,//总共页面数量
      currentPage:0,
      
      memCouponMsg: [], //获取我的优惠券列表有效
      memCouponMsgExpireList: [], //无效优惠券
      toast1: false, //删除提示信息
    }
  },
  mounted() {
    this.scroller = document.querySelectorAll('.' + this.activeTab)[0];
  },
  methods: {
    ...mapActions({
      pageMemRedpacket: 'pageMemRedpacket', //获取我的优惠券
      delMemCoupon: 'delMemCoupon', //删除优惠券
    }),
    // 加载更多
    loadMore() {
      let type = 0;
      if(this.activeTab == 'tab1'){
        type = 0;
      }else if(this.activeTab == 'tab2'){
        type = 2;
      }
      if(this.lastPageNo == this.currentPage){
        this.loading = false;
      }else{
        this.loading = true;
        this.pageNo ++ ;
        this.getPageMemRedPacket(type, this.pageNo, this.pageSize);
        setTimeout(() => {          
          this.loading = false
        }, 2000)
      }
    },
    tabHeaderOne(type) {
      if(this.activeTab == 'tab1'){
        return;
      }
      this.loadShow = true; //加载
      this.activeTab = 'tab1';
      // 数据列表清空
      this.pageNo = 1;
      this.memCouponMsg  =[];
      this.getPageMemRedPacket(type, this.pageNo, this.pageSize);
    },
    //打开已经失效的优惠券
    tabHeaderTwo(type) {
      if(this.activeTab == 'tab2'){
        return;
      }
      this.loadShow = true; //加载
      this.activeTab = 'tab2';
      // 数据列表清空
      this.pageNo = 1;
      this.memCouponMsg  =[];
      this.getPageMemRedPacket(type, this.pageNo, this.pageSize);
    },
    //检查详情是否打开
    check(index) {
      for (var i = 0; i < this.scandetailid.length; i++) {
        if (this.scandetailid[i] == index)
          return true;
      }
    },
    //打开详情
    scandetail(index) {
      if (this.check(index)) { //检查标签已经选中
        for (var i = 0; i < this.scandetailid.length; i++) {
          if (this.scandetailid[i] == index)
            this.scandetailid.splice(i, 1);
        }
      } else {
        this.scandetailid.push(index);
      }
    },
    //删除我的优惠券按钮
    deleteitem(couponInstId) {
      this.delCoupon=true;
      this.temp = couponInstId;
      // this.getDelMemCoupon(couponInstId);
    },
    //进入订单详情
    gouse(storeId, useType) {
      this.$router.push({
        path: '/main/home'
      })
    },
    //获取我的优惠券列表api
    getPageMemRedPacket(couponState, pageNo, pageSize) {
      this.pageMemRedpacket([couponState, pageNo, pageSize]).then(res => {
        res.result.forEach(item => {
           this.memCouponMsg.push(item)
        })
        this.lastPageNo = Number(res.lastPageNo);
        this.currentPage = Number(res.currentPageNo);
        this.total = Number(res.totalCount);
        this.loadShow = false; //加载结束
        this.loadShow = false; //加载结束
      }).catch(error => {})
    },
    //删除当签优惠券api
    getDelMemCoupon(couponInstId) {
      this.delMemCoupon(couponInstId).then(res => {
        this.delCoupon=false;
        this.toast1 = true;
        setTimeout(() => { this.toast1 = false }, 1500);
        this.getPageMemRedPacket(0, this.pageNo, this.pageSize);
      }).catch(error => {});
    }
  },
  created() {
    
    //获取我的优惠券列表
    this.getPageMemRedPacket(0, this.pageNo, this.pageSize);

    //this.getDelMemCoupon(32132132);
  },
  watch: {},
  components: {
    menus,
    myOrdersItem,
    empty
  },
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'personal.scss';

</style>



// WEBPACK FOOTER //
// myredpack.vue?1afeff58